var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expand-transition',[(_vm.display)?_c('v-banner',{attrs:{"color":"white","elevation":"1","icon":"mdi-check-outline","single-line":""}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }